module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-results-photo-01.jpg?h=02e1bba0a16414f125db04239049737d";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-results-photo-01.jpg
// module id = 2106
// module chunks = 12 15